module.exports = __webpack_public_path__ + "static/media/Dyal SIngh Building c. 1930s.669a0e87.jpg";